@if ((state$ | async) === States.error) {
  <kgr-errors errors="Es ist leider ein unerwarteter Fehler aufgetreten." i18n-errors></kgr-errors>
}

<div [kgrLoading]="(state$ | async) === States.processing" [kgrLoadingBlocking]="true">
  @for (loginUserToken of loginUserTokens$ | async; track loginUserToken) {
    <ng-container class="kgr-list__item">
      <hr class="kgr-separator kgr-separator--light" />
      <button type="button" (click)="loginByLoginUserToken(loginUserToken)" class="kgr-link kgr-clickable kgr-clickable--touchy" i18n>
        Anmelden bei <b class="kgr-text kgr-text--bold">"{{ loginUserToken.institutionName }}"</b> als
        <b class="kgr-text kgr-text--bold">{{ loginUserToken.name }}</b>
      </button>
    </ng-container>
  }
  <hr class="kgr-separator kgr-separator--light" />
  <button class="kgr-link" (click)="onLogoutClick()" i18n>Benutzer ausloggen</button>
</div>
